import React from 'react';
import { Menu, Bell } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function Header({ onMenuToggle, title }) {
  const { user } = useAuth();

  return (
    <header className="bg-dark-900/50 backdrop-blur-md border-b border-dark-700 px-4 lg:px-6 py-4 sticky top-0 z-30">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={onMenuToggle}
            className="lg:hidden p-2 text-dark-300 hover:text-white rounded-lg hover:bg-dark-800"
          >
            <Menu className="w-5 h-5" />
          </button>
          <h2 className="text-lg font-semibold text-white">{title}</h2>
        </div>
        <div className="flex items-center gap-3">
          <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
            user?.role === 'admin' ? 'bg-purple-500/10 text-purple-400 border border-purple-500/20' :
            user?.role === 'voip_agent' ? 'bg-green-500/10 text-green-400 border border-green-500/20' :
            'bg-blue-500/10 text-blue-400 border border-blue-500/20'
          }`}>
            {user?.role === 'admin' ? 'Admin' : user?.role === 'voip_agent' ? 'VoIP Agent' : 'Normal Agent'}
          </span>
        </div>
      </div>
    </header>
  );
}
